import config from "../config/config";
import { getToken } from "../utils/prefix";

/**
 * ดึงรายชื่อสมาชิกที่ยังไม่มีทีมใน task
 */
export async function team_getMemberNotInTeam(data) {
  const res = await fetch(config.api_backend + `/team/getmemberonteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ดึง user ทุกคนที่ยังไม่ได้ register task นี้ (ไม่สนใจว่าเคย register task อื่นแล้วหรือไม่)
 */
export async function team_getUserNotInTask(task_id) {
  const res = await fetch(config.api_backend + `/team/getusernotintask`, {
    body: JSON.stringify({ task_id }),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ดึงรายชื่อสมาชิกทั้งหมดใน task (รวมทั้งที่มีทีมและไม่มีทีม)
 */
export async function team_getMemberInTask(data) {
  const res = await fetch(config.api_backend + `/team/getmemberintask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * สร้างทีมใหม่
 */
export async function team_create(data) {
  const res = await fetch(config.api_backend + `/team/createteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * อัพเดทสมาชิกในทีม
 */
export async function team_updateMember(data) {
  const res = await fetch(config.api_backend + `/team/updatemember`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * เปลี่ยนชื่อทีม
 */
export async function team_updateName(data) {
  const res = await fetch(config.api_backend + `/team/updatenameteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ลบสมาชิกออกจากทีม
 */
export async function team_deleteMember(data) {
  const res = await fetch(config.api_backend + `/team/deletemember`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ลบทีม (เฉพาะทีมที่มีสมาชิกคนเดียว)
 */
export async function team_delete(data) {
  const res = await fetch(config.api_backend + `/team/deleteteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ลบทีม (admin/superadmin ลบได้ทุกทีม ไม่จำกัดจำนวนสมาชิก)
 */
export async function team_deleteByAdmin(data) {
  const res = await fetch(config.api_backend + `/team/deleteteambyadmin`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ลบผู้ใช้ออกจาก task (ลบ row จาก task_member)
 */
export async function team_deleteUserFromTask(data) {
  const res = await fetch(config.api_backend + `/team/deleteuserfromtask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ดึงรายการทีมทั้งหมดแบบแบ่งหน้า ที่อยู่ใน task นั้น
 */
export async function team_getAll(data) {
  const res = await fetch(config.api_backend + `/team/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * ดึงข้อมูลทีมเดียว
 */
export async function team_getOne(data) {
  const res = await fetch(config.api_backend + `/team/getone`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * เปลี่ยนหัวหน้าทีม
 */
export async function team_changeLeader(data) {
  const res = await fetch(config.api_backend + `/team/changeTeamLeader`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

/**
 * อัพเดท role ของสมาชิกในทีม
 */
export async function team_updateMemberRole(data) {
  const res = await fetch(config.api_backend + `/team/updateMemberRole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_updatestatusteam(data) {
  const res = await fetch(config.api_backend + `/team/updatestatusteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_updatestatususer(data) {
  const res = await fetch(config.api_backend + `/team/updatestatususer`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_updateTaskRole(data) {
  const res = await fetch(config.api_backend + `/team/updatetaskrole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_getteamconfig(data) {
  const res = await fetch(config.api_backend + `/team/getteamconfig`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });

  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_getMyTeam(data) {
  const res = await fetch(config.api_backend + `/team/myteam`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  const dataResponse = await res.json();
  return dataResponse;
}

export async function team_getMyTaskRole(data) {
  const res = await fetch(config.api_backend + `/team/mytaskrole`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "x-access-token": getToken(),
      "Content-type": "application/json",
    },
  });
  return res.json();
}